import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import AccountSidebar from "./AccountSidebar";

export default function AccountPage({
  children,
  title = "My Account",
}) {
  return (
    <>
      <Header />

      <main className="min-h-screen bg-[#F7F1E3]">

        {/* Hero */}
        <div className="bg-[#FFFDF8] border-b border-[#E5DDCC]">
          <div className="max-w-7xl mx-auto px-6 py-10">

            {/* Breadcrumb */}
            <p className="text-sm text-[#8A8172]">
              Home
              <span className="mx-2 text-[#C8BDAA]">
                /
              </span>

              <span className="text-[#0F766E] font-medium">
                {title}
              </span>
            </p>

            {/* Title */}
            <h1 className="
              text-4xl
              font-bold
              mt-3
              text-[#1F2937]
            ">
              {title}
            </h1>

          </div>
        </div>

        {/* Content */}
        <div className="max-w-7xl mx-auto px-6 py-10">

          <div className="
            grid
            grid-cols-1
            lg:grid-cols-4
            gap-8
          ">

            {/* Sidebar */}
            <div className="lg:col-span-1">
              <AccountSidebar />
            </div>

            {/* Page */}
            <div className="lg:col-span-3">
              {children}
            </div>

          </div>

        </div>

      </main>

      <Footer />
    </>
  );
}